/* unplugin-vue-components disabled */import script from "./LastestOrderPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./LastestOrderPanel.vue?vue&type=script&setup=true&lang=js"

import "./LastestOrderPanel.vue?vue&type=style&index=0&id=7bc0e86c&lang=scss"

const __exports__ = script;

export default __exports__